import { supabase } from '../../../shared/lib/supabaseClient';

export async function getPublicProjects() {
  const { data, error } = await supabase
    .from('projects')
    .select('id, name, category, amount, expense_date, voucher_number, recipient, status')
    .order('expense_date', { ascending: false });

  if (error) throw error;
  return data;
}
